import { NavLink, Outlet, useNavigate } from 'react-router-dom'

import { useAuth } from '../auth/context'

/**
 * The chrome every authenticated page sits inside. Navigation is a flat list for now —
 * it grows into sections when there are enough modules to organise.
 */
export function AppShell() {
  const { principal, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="shell">
      <header className="shell-header">
        <div className="shell-brand">
          <span className="brand-mark">LC</span>
          <span className="brand-name">logistics-crm</span>
        </div>

        <nav className="shell-nav">
          <NavLink to="/" end>
            Dashboard
          </NavLink>
          <NavLink to="/customers">Customers</NavLink>
        </nav>

        <div className="shell-account">
          <span className="muted">{principal?.subject}</span>
          <button type="button" className="btn btn-quiet" onClick={handleLogout}>
            Sign out
          </button>
        </div>
      </header>

      <main className="shell-main">
        <Outlet />
      </main>

      <footer className="shell-footer muted">
        Alpha build — not for customer data yet.
      </footer>
    </div>
  )
}
